import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const FilterNavContainer = styled(Box)`
  min-width: 250px;
  background-color: #fafafa;
  padding: 20px 0 20px 20px;
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
`;
